import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import DocG from 'src/assets/docg.png';

const AppRedirectPage = () => {
    const { clinicId } = useParams();
    const appDeepLink = `docgai://signup/${clinicId}`;
    const playStoreLink = 'https://play.google.com/store/apps/details?id=com.docgai&pcampaignid=web_share';

    useEffect(() => {
        window.location = appDeepLink;
        const timeoutId = setTimeout(() => {
            window.location = playStoreLink;
        }, 3000);

        return () => clearTimeout(timeoutId);
    }, [appDeepLink, playStoreLink]);

    return (
        <div style={{ textAlign: 'center', marginTop: '15%' }}>
            <Helmet>
                <title>Opening DocGai App | DOCG</title>
            </Helmet>
            <p><img src={DocG} alt='docg' style={{ height: '70px', borderRadius: '8px' }} /></p>
            <p>Please wait. Opening the DocGai app...</p>
            <p>If the app isn't found, you will be redirected to the Play Store.</p>
        </div>
    )
}

export default AppRedirectPage;